import { useLoader } from "@react-three/fiber";
import { TextureLoader, DoubleSide } from "three";
import { MEZZANINE_Y } from "../../lib/consts";

export default function WallDecorations() {
	const tex = useLoader(TextureLoader, "/logo/logo.png");
	const w = 8.4;
	const h = 7;
	const wallH = MEZZANINE_Y;

	return (
		<>
			<mesh position={[0, wallH / 2, -9.79]}>
				<planeGeometry args={[w, h]} />
				<meshStandardMaterial map={tex} transparent side={DoubleSide} />
			</mesh>
		</>
	);
}